export const PROPERTY_TYPES = [
    { value: "HOUSE", labelKey: "form.estimation.property-type.house" },
    { value: "APARTMENT", labelKey: "form.estimation.property-type.apartment" },
    {
        value: "INCOME_PROPERTY",
        labelKey: "form.estimation.property-type.income-property",
    },
    { value: "LAND", labelKey: "form.estimation.property-type.land" },
    { value: "OFFICE", labelKey: "form.estimation.property-type.office" },
    {
        value: "COMMERCIAL",
        labelKey: "form.estimation.property-type.commercial",
    },
    {
        value: "INDUSTRIAL",
        labelKey: "form.estimation.property-type.industrial",
    },
];
